import { observer } from 'mobx-react';

import { useSideMenu } from '../../hooks/useSideMenu';
import { FreeDaubNotificationDot } from '../Notifications/FreeDaubNotificationDot';
import { NotificationDotController } from '../Notifications/NotificationDotController';
import { Hamburger } from '../SVGIcons/Hamburger';

import classes from './Headers.module.scss';

export const MenuToggle = observer(function MenuToggle() {
  const { handleToggle } = useSideMenu();

  return (
    <button className={classes.hamburger} data-testid="menuButton" onClick={handleToggle}>
      <Hamburger />
      <div className={classes.dot_wrapper}>
        <FreeDaubNotificationDot type="small" />
        <NotificationDotController type="small" />
      </div>
    </button>
  );
});
